import React from 'react';
import { useTheme } from '../../context/ThemeContext';
import { Icon } from '../ui/Icon';

type Size = 'sm' | 'md';

export const ThemeToggle: React.FC<{ size?: Size }> = ({ size = 'sm' }) => {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === 'dark';
  const label = isDark ? 'Switch to light mode' : 'Switch to dark mode';
  return (
    <button
      type="button"
      className={`btn btn-ghost ${size === 'sm' ? 'btn-sm' : ''}`}
      title={label}
      aria-label={label}
      aria-pressed={isDark}
      onClick={toggleTheme}
    >
      <Icon name={isDark ? 'sun' : 'moon'} size={size === 'sm' ? 16 : 18} />
    </button>
  );
};

export default ThemeToggle;
